<template>
  <div class="page-container">
    <div class="query-title">材料计划期初导入</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="upload" tip="选择文件" @click="handleImportExcel('matInitDetail')" />
            <table-button name="export" tip="保存" @click="handleSaveImportExcel" />
            <table-button name="download" tip="下载模板" @click="downloadTemplate('matInitDetail')" />
            <table-button name="delete" tip="删除" @click="handleDelImportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <span>{{ row[item.field] }}</span>
              </div>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import {
  apiExportExcelTemplate,
  apiExcelImport,
  apiGetExcelImportData
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'

import { apiMaterialInitImportList, apiMaterialInitImportSave, apiMaterialInitImportSavecheck, apiMaterialInitImportDel } from '@/api/sap/material-plan'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/materialPlanImport'
import { frontExport, exportAll } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      conditions: {
        templateCode: '',
        batchNumber: ''
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox', width: 50 }],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    // 模板下崽
    async downloadTemplate(tem) {
      const res = await apiExportExcelTemplate(tem)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=材料计划期初导入模板`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', '材料计划期初导入模板')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    // 导入excel
    async handleImportExcel(tem) {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: tem
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.conditions.templateCode = tem
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    async handleDelImportExcel() {
      const checkedData = this.$refs.xTable.getCheckboxRecords()
      if (!checkedData?.length) return this.$message.warning('请选择要删除的数据！')

      const ids = checkedData.map(v => v._X_ID)
      // 如果选择的所有数据都是没有保存的
      if (checkedData.every(item => !item.packpl_id)) {
        this.gridOptions.data = this.gridOptions.data.filter(item => {
          return !ids.includes(item._X_ID)
        })
        return
      } else if (checkedData.some(item => !item.packpl_id)) {
        this.$message.success('请选择已经保存的数据或者未保存的数据！')
        return
      } else {
        const res = await apiMaterialInitImportDel({
          select: checkedData
        })
        if (res.msgtype === 'S') {
          this.gridOptions.data = this.gridOptions.data.filter(item => {
            return !ids.includes(item._X_ID)
          })
        } else {
          this.$message.error(res.message)
        }
      }
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)
      if (!res.data.Rows.length) return this.$message.error('不能导入空数据！')
      // 转换一哈驼峰
      for (const item of res.data.Rows) {
        // 转换大小写
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          if (this.toLineAndUp(key) !== key) {
            delete item[key]
          }
        })
      }
      const result = await apiMaterialInitImportSavecheck({
        item: res.data.Rows,
        user_bp: this.role.USER_BP
      })
      if (result.msgtype === 'S') {
        this.gridOptions.data = result.item
      } else {
        this.$message.error(result.message)
      }
    },
    // 驼峰转成下划线
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    // 保存
    async handleSaveImportExcel() {
      if (!this.gridOptions.data.length) return this.$message.warning('没有可以保存的数据！')
      const params = {
        user_bp: this.role.USER_BP,
        item: this.gridOptions.data
      }
      const res = await apiMaterialInitImportSave(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        this.gridOptions.data = []
      } else {
        this.$message.error(res.message)
      }
    },
    toDetail(row) {
      this.$emit('change-action', 'batch', row.batch_number)
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        partner: this.role.USER_BP,
        roles: this.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiMaterialInitImportList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // // 导出全部 导出本页
    // async exportExcel(type) {
    //   if (!this.gridOptions.data.length) {
    //     await this.queryData()
    //   }
    //   // 导出本页
    //   if (type === 'page') {
    //     frontExport(this.gridOptions.columns, this.gridOptions.data, '经销商开票情况明细报表')
    //   } else {
    //     // 导出全部
    //     const params = {
    //       ...filterSapParams(this.conditions),
    //       user_bp: this.role.USER_BP,
    //       role: this.role.ROLE,
    //       ...this.pagination
    //     }
    //     const options = {
    //       columns: this.gridOptions.columns,
    //       resk: 'data',
    //       fileName: '经销商开票情况明细报表'
    //     }
    //     exportAll(reportForm1, params, options)
    //   }
    // },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/materialPlanImport.vue